export const GET_ALL_USER_PLANTS = "GET_ALL_USER_PLANTS"
export const SEARCH_USER_PLANTS = "SEARCH_USER_PLANTS"
